import type { SearchAlgoliaGoldenHit } from '#/modules/search/algolia/types/SearchAlgoliaGoldenHit';

export const VOLOP_IMPORTED_TYPE_MAP: Record<
  SearchAlgoliaGoldenHit['source'],
  string
> = {
  GOLDEN: 'Golden',
};
